export * from './enums';
export const FALLBACK_COMPETITION_LOGO_PATH = '/assets/icons/ziggo_sport_logo.png';
// Provided by Webpack.
export const APP_VERSION = window.APP_SETTINGS.appVersion;
export const ADYEN_CLIENT_KEY = window.APP_SETTINGS.adyenClientKey;
export const ADYEN_ENVIRONMENT = window.APP_SETTINGS.adyenEnvironment === 'live' ? 'live' : 'test';
